export const DISABLED_COLOR = "#B3BCC0";
export const SELECTED_COLOR = "#1CBD93";
export const MY_PURCHASED_COLOR = "#E98687";
export const MY_CART_COLOR = "#E6E6E6";
export const PARTIALY_BOOKED_COLOR = "#E9FF70";
export const DISABLED_CUBE_COLOR = {
    leftFace: "#B8CAC5",
    rightFace: "#A5A3A3",
    topFace: "#DFE7E9"
}
export const SELECTED_CUBE_COLOR = {
    leftFace: "#27A081",
    rightFace: "#077054",
    topFace: "#1FDEAC"
}
export const MY_PURCHASED_CUBE_COLOR = {
    leftFace: "#D26162",
    rightFace: "#CF4E4E",
    topFace: "#F67677"
}

export const formatMatchDetails = (dateString) => {
    const date = new Date(dateString);
    const currentYear = new Date().getFullYear();
    const dateYear = date.getFullYear();

    const formattedDate = date.toLocaleDateString("en-US", {
        weekday: "short",
        day: "2-digit",
        month: "short",
        ...(dateYear > currentYear && { year: "numeric" }),
    });
    return formattedDate
};

export const PredefinedColors = [
    {
        id: 1,
        name: "My Purchased Tokens",
        color: MY_PURCHASED_COLOR
    },
    {
        id: 2,
        name: "My Cart Tokens",
        color: MY_CART_COLOR
    },
    {
        id: 3,
        name: "Booked for Entire Season",
        color: DISABLED_COLOR
    },
    {
        id: 4,
        name: "Partially Booked",
        color: PARTIALY_BOOKED_COLOR
    },
    {
        id: 5,
        name: "Current Selected Tokens",
        color: SELECTED_COLOR
    },
]